import { useRef } from 'react';
const useInstitutionVerificationFormRefs = () => {
    const orderedRefs = [
        ['message', useRef(null)],
        ['file', useRef(null)],
    ];
    return { refs: Object.fromEntries(orderedRefs), orderedRefs };
};
export default useInstitutionVerificationFormRefs;
